import categoryService from '../../services/ClassenService/modules/categoryService';

const state = {
  categories: [],
  categoriesFacets: [],
};

const mutations = {};

const getters = {};

const actions = {
  getCategories: ({commit}) => new Promise((resolve, reject) => {
    categoryService.getCategories()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getCategory: ({commit}, categoryId) => new Promise((resolve, reject) => {
    categoryService.getCategory(categoryId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateCategory: ({commit}, categoryId, categoryData) => new Promise((resolve, reject) => {
    categoryService.updateCategory(categoryId, categoryData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteCategory: ({commit}, categoryId) => new Promise((resolve, reject) => {
    categoryService.deleteCategory(categoryId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addCategory: ({commit}, categoryData) => new Promise((resolve, reject) => {
    categoryService.addCategory(categoryData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getCategoriesFacets: ({commit}) => new Promise((resolve, reject) => {
    categoryService.getCategoriesFacets()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

};

export default {
  state, mutations, getters, actions,
};
